const getError = (code = '', message = '') => ({ global: { violations: [{ code, message }] } });

const CANNOT_TURN_OFF_QUICK_BET = 'CANNOT_TURN_OFF_QUICK_BET';
export const CANNOT_TURN_OFF_QUICK_BET_ERROR = getError(CANNOT_TURN_OFF_QUICK_BET);

export const betslipTabIndex = 0;
export const myBetsTabIndex = 1;
